// Status pipeline definitions used across the app
export const STATUSES = [
  { value: "idea",       label: "Idea",          dot: "dot-idea",       text: "text-idea" },
  { value: "demo",       label: "Demo",          dot: "dot-demo",       text: "text-demo" },
  { value: "production", label: "In Production", dot: "dot-production", text: "text-production" },
  { value: "mixing",     label: "Mixing",        dot: "dot-mixing",     text: "text-mixing" },
  { value: "mastering",  label: "Mastering",     dot: "dot-mastering",  text: "text-mastering" },
  { value: "final",      label: "Final / Ready", dot: "dot-final",      text: "text-final" },
  { value: "scheduled",  label: "Scheduled",     dot: "dot-scheduled",  text: "text-scheduled" },
  { value: "released",   label: "Released",      dot: "dot-released",   text: "text-released" },
  { value: "shelved",    label: "Shelved",       dot: "dot-shelved",    text: "text-shelved" },
];

export const statusByValue = (v) => STATUSES.find((s) => s.value === v) || STATUSES[0];

export const RELEASED_STATUSES = ["released"];
export const UNRELEASED_STATUSES = ["idea", "demo", "production", "mixing", "mastering", "final", "scheduled"];
export const SHELVED_STATUSES = ["shelved"];

export const PROS = ["", "ASCAP", "BMI", "SESAC", "GMR", "Other"];

// R6 — Songview-style deep-links. No fetching/scraping — client-side links only.
// ASCAP: Work ID when known, else title search (confirmed live Sep 14, 2026).
// BMI: homepage link (the pre-filled pattern is unverified; switch only when captured live).
export const SONGVIEW_LINKS = (track) => {
  const t = encodeURIComponent(track.title || "");
  const ext = track.external_ids || {};
  const ascapWorkId = ext.ascap_work_id;
  const ascap = ascapWorkId
    ? `https://www.ascap.com/repertory#/ace/search/workID/${encodeURIComponent(ascapWorkId)}`
    : `https://www.ascap.com/repertory#/ace/search/title/${t}?at=false&searchFilter=SVW&page=1`;
  return [
    { label: ascapWorkId ? "ASCAP · Work ID" : "ASCAP ACE", url: ascap, primary: true },
    { label: "BMI Repertoire", url: "https://repertoire.bmi.com/" },
    { label: "SESAC Repertory", url: "https://www.sesac.com/repertory/" },
    { label: "GMR", url: "https://globalmusicrights.com/" },
  ];
};

export const MANUAL_LOOKUP_LINKS = (track) => {
  const t = encodeURIComponent(track.title || "");
  const a = encodeURIComponent(track.primary_artist || "");
  const isrc = encodeURIComponent(track.isrc || "");
  const iswc = encodeURIComponent(track.iswc || "");
  return [
    { label: "MLC Works",   url: `https://portal.themlc.com/search?searchText=${t}` },
    { label: "ISWCnet",     url: iswc ? `https://iswcnet.cisac.org/search/swrSearch?iswc=${iswc}` : `https://iswcnet.cisac.org/search/swrSearch` },
    { label: "SoundExchange", url: isrc ? `https://www.soundexchange.com/artist-copyright/isrc-search/?isrc=${isrc}` : `https://www.soundexchange.com/artist-copyright/isrc-search/` },
    { label: "US Copyright Catalog", url: `https://cocatalog.loc.gov/cgi-bin/Pwebrecon.cgi?DB=local&v1=1&ti=1,1&Search_Arg=${t}&Search_Code=TALL&CNT=25&PID=&SEQ=&SID=1` },
    { label: "Spotify Search", url: `https://open.spotify.com/search/${t}%20${a}` },
    { label: "Apple Music", url: `https://music.apple.com/us/search?term=${t}+${a}` },
    { label: "YouTube Music", url: `https://music.youtube.com/search?q=${t}+${a}` },
    { label: "Discogs",     url: `https://www.discogs.com/search/?q=${t}+${a}&type=release` },
    { label: "MusicBrainz", url: isrc ? `https://musicbrainz.org/isrc/${isrc}` : `https://musicbrainz.org/search?type=recording&query=${t}+${a}` },
  ];
};

// R5 — "What's missing" item → edit-modal section it lives in
export const MISSING_SECTION = {
  TITLE: "core", PRIMARY_ARTIST: "core", RELEASE_DATE: "core", STATUS: "core", LABEL: "core",
  ISRC: "metadata", ISRC_NEEDS_REVIEW: "metadata", ISWC: "metadata", BPM: "metadata", KEY: "metadata",
  GENRE: "metadata", DURATION: "metadata",
  WRITER: "credits", PRODUCER: "credits",
  PRO: "registrations", MLC: "registrations", SOUNDEXCHANGE: "registrations", PUBLISHER: "registrations",
};
